import { useEffect } from "react";

export function usePageTitle(title = 'BlueHalo') {
    useEffect(() => {document.title = title;},[title]);
}
